import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './routers/routes';
import 'react-photo-view/dist/react-photo-view.css';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// AOS configuration for subtle, modern animations
AOS.init({
  duration: 700,
  easing: 'ease-out-cubic',
  once: true,
  offset: 80,
});

function App() {
  return (
    <>
      <RouterProvider router={router}/>
    </>
  );
}

export default App;
